import * as React from "react"
import { cn } from "@/lib/utils"

function Skeleton({
  className,
  delay = 0,
  ...props
}: React.ComponentProps<"div"> & {
  /** Delay in ms before showing the skeleton, so fast loads never flash one. */
  delay?: number
}) {
  const [visible, setVisible] = React.useState(delay === 0)

  React.useEffect(() => {
    if (delay === 0) return
    const timer = setTimeout(() => setVisible(true), delay)
    return () => clearTimeout(timer)
  }, [delay])

  if (!visible) return null

  return (
    <div
      data-slot="skeleton"
      className={cn("bg-border rounded-md animate-pulse", className)}
      {...props}
    />
  )
}

export { Skeleton }
